import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex)

export default new vuex.Store({
  state: {
    // 存储token
    Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',

    userInfo: localStorage.getItem('userInfo') ? localStorage.getItem('userInfo') : '',

    openId: localStorage.getItem('openId') ? localStorage.getItem('openId') : ''
  },

  mutations: {
    // 修改token，并将token存入localStorage
    changeLogin (state, data) {
      state.Authorization = data.Authorization
      localStorage.setItem('Authorization', data.Authorization)
    },
    // 用户信息
    userInfo (state, data) {
      state.userInfo = data.userInfo
      localStorage.setItem('userInfo', data.userInfo)
    },
    // openid
    openId (state, data) {
      state.openId = data.openId
      localStorage.setItem('openId', data.openId)
    },
    // 退出
    logout (state) {
      localStorage.clear()
      // state.openId = null
      state.Authorization = null
      state.userInfo = {}
    }

  }
})



// WEBPACK FOOTER //
// ./src/store/index.js